export default __webpack_public_path__ + "static/media/icon-findability.5bcd88e9.svg";